export default function createAnchorLinks () {
  let anchorsArray = [];
  let anchorTagExists;

  let headings;
  let headings3;
  let anchors;

  headings = document.querySelectorAll('h2');
  headings3 = document.querySelectorAll('h3');
  anchors = document.querySelectorAll('a')
  
  let arr = Array.from(anchors)
  
  arr.map(el => {
    if ( el.getAttribute('id') || el.getAttribute('name') ){
      el.style.scrollMarginTop = "50px";
    }
    if (el.getAttribute('href')) {
      if (el.getAttribute('href').startsWith('#')) {

        anchorsArray.push(el.getAttribute('href').slice(1))

        el.parentElement && el.parentElement.classList.add("article-content-navigation")

        if ( el.getAttribute('id') || el.getAttribute('name') ){
          anchorTagExists = true;
          el.style.scrollMarginTop = "100px";
        }
      }
    }
  })

  if(!anchorTagExists){
    headings.forEach((h2, i) => {
      let index = i +1;

      if (index <= anchorsArray.length) {
        h2.setAttribute('id', anchorsArray[i]);
        h2.style.scrollMarginTop = "100px";
      }
    });

  }

    headings3.forEach((h3, i) => {
      h3.style.scrollMarginTop = "100px";
    });
}